import { Row, Col, Progress } from "antd"
import { useSocketEvent } from "../contexts/SocketContext"
import { useCallback, useState } from "react"

const Usages = () => {
    const [serverUsage, setServerUsage] = useState()

    const serverUsageHandler = useCallback((usage) => {
        setServerUsage(usage)
    }, [])

    useSocketEvent("serverUsage", serverUsageHandler)

    return (
        <>
            <div className="">
                <Row justify="space-evenly">
                    <Col span={8} style={{ textAlign: "center" }}>
                        <Progress
                            type="dashboard"
                            percent={serverUsage?.diskUsage.percent}
                            status="normal"
                            gapDegree={100}
                            size={80}
                            trailColor="#2c3950"
                            format={(percent) => (
                                <span className="" style={{ color: "#e4e4e7" }}>
                                    {percent}%
                                </span>
                            )}
                        />
                        <div className=" bold">
                            Disk: {serverUsage?.diskUsage.used} / {serverUsage?.diskUsage.total}
                        </div>
                    </Col>
                    <Col span={8} style={{ textAlign: "center" }}>
                        <Progress
                            type="dashboard"
                            percent={serverUsage?.memoryUsage.percent}
                            status="normal"
                            size={80}
                            gapDegree={100}
                            trailColor="#2c3950"
                            format={(percent) => (
                                <span className="" style={{ color: "#e4e4e7" }}>
                                    {percent}%
                                </span>
                            )}
                        />
                        <div className=" bold">
                            RAM: {serverUsage?.memoryUsage.usedMemory} / {serverUsage?.memoryUsage.totalMemory}
                        </div>
                    </Col>
                    <Col span={8} style={{ textAlign: "center" }}>
                        <Progress
                            type="dashboard"
                            percent={serverUsage?.cpuUsage.percent}
                            status="normal"
                            size={80}
                            gapDegree={100}
                            trailColor="#2c3950"
                            format={(percent) => (
                                <span className="" style={{ color: "#e4e4e7" }}>
                                    {percent}%
                                </span>
                            )}
                        />
                        <div className=" bold">CPU: Core {serverUsage?.cpuUsage.coreCount}</div>
                    </Col>
                </Row>
            </div>
        </>
    )
}

export default Usages
